import { render, staticRenderFns } from "./UsuariosEliminadosPage.vue?vue&type=template&id=070fee79"
import script from "./UsuariosEliminadosPage.js?vue&type=script&lang=js&external"
export * from "./UsuariosEliminadosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports